import {useEffect} from 'react';
import axios from 'axios';

import sdk from '@/sdk';
import * as store from '@/store';
import {ServerConfig} from '@/config/routers';
import eventBus, {EDITOR_FS_DOM_READY} from '@/eventBus';

let prevDocGuid = '';

export const useAiTaskSubmit = (curDoc?: WizDocument) => {
    useEffect(() => {
        const submit = () => {
            if (window.isTocPage || !curDoc || curDoc.docGuid === prevDocGuid) {
                return;
            }

            const {userGuid, publisherGuid} = curDoc;
            if ([userGuid, publisherGuid].includes(sdk.user?.userGuid)) {
                return;
            }

            prevDocGuid = curDoc.docGuid;
            const tokenObj = store.getData(store.KEYS.CUR_DOCUMENT_TOKEN);
            const rteToken = tokenObj?.accessToken;
            if (!rteToken) {
                return;
            }
            sdk.as.request({
                method: 'POST',
                url: `${ServerConfig.origin}/wiki/ai/task/submit`,
                data: {
                    sync: false,
                    level: 0,
                    source: 'preview',
                },
                headers: {
                    Authorization: rteToken,
                },
            });
        };
        eventBus.on(EDITOR_FS_DOM_READY, submit);

        return () => {
            eventBus.off(EDITOR_FS_DOM_READY, submit);
        };
    }, [curDoc]);
};
